export const FIELD_SIZES = {
  NUMBER: 9999999,
  SHORT_TEXT: 128,
  TEXT: 255,
};
